import {
  ActivityPacing,
  ActivityType,
} from '@showbie-socrative/socrative-utils';

import { RoomTypes } from '~analytics/types';
import { FinishRoute } from '~analytics/types';

import { sendFinishActivityEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface FinishActivityEventAdapterParams {
  settings: any;
  activityType: ActivityType | string;
  isRosteredRoom: boolean;
  numberStudents: number;
  numberResponses: number;
  startTime: string;
  endTime: string;
  finishRoute: FinishRoute;
}

export class FinishActivityEventAdapter extends EventAdapter {
  protected intercomEventKey = 'finish-activity';
  protected amplitudeEventFunction = sendFinishActivityEvent;

  constructor({
    settings,
    activityType,
    isRosteredRoom,
    numberStudents,
    numberResponses,
    startTime,
    endTime,
    finishRoute,
  }: FinishActivityEventAdapterParams) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      let deliveryMethod = 'instant_feedback';

      if (settings.pacing === ActivityPacing.Teacher)
        deliveryMethod = 'teacher_paced';
      if (settings.allowStudentNav) deliveryMethod = 'open_navigation';

      this.eventData = {
        room_type: roomType,
        activity_type: activityType,
        delivery_method: deliveryMethod,
        activity_require_names: settings.requireNames,
        activity_shuffle_questions: settings.randomQuestions,
        activity_shuffle_answers: settings.randomAnswers,
        activity_show_question_feedback: settings.showFeedback,
        activity_show_final_score: settings.showResults,
        activity_one_attempt: settings.oneAttempt,
        number_of_students: numberStudents,
        number_of_responses: numberResponses,
        start_time: startTime,
        end_time: endTime,
        finish_route: finishRoute,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
